<template>
  <v-container fluid>
    <v-alert type="warning" max-width="600" icon="mdi-alert-octagon" class="mx-auto mt-5 material-icons-outlined" dark
      prominent>
      <h2>License required.</h2>
      You can contact Qwips support by email to support@qwips.no if you are interested in getting a license for use of
      this page.
      <!--
        //TODO: make license information page here where they can see what the license offers and link to about page for license overview.
        Im not gonna translate the text here for now as the text will be depricated when this is done.
      -->
    </v-alert>
  </v-container>
</template>


<script>
export default {
  name: 'UnLicensedAccess',
  props: {},
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>